/**
 * @name vote
 * @description Hlasovat. V odpovědi chodí data s výsledky pro danou anketu.
 *
 * @param {String} answerId
 * @param {String} questionId
 * @returns {String}
 */
export const vote = (answerId, questionId) => `/enquiries/${answerId}/vote/${questionId}`;

/**
 * @name update
 * @description Načtení výsledků ankety.
 *
 * @param {String} enquiryId
 * @returns {String}
 */
export const update = (enquiryId) => `/enquiries/${enquiryId}/load`;
